import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { KnBrDownloadConfirmationDialogComponent } from 'src/app/sales-libs/kn-br-nac/components/kn-br-download-confirmation-dialog/kn-br-download-confirmation-dialog.component';
import { TranslatePipe } from '@spartacus/core';
 
@Component({
    selector: 'knbr-sloan-download-confirmation-dialog',
    templateUrl: './sloan-download-confirmation-dialog.component.html',
    styleUrls: ['./sloan-download-confirmation-dialog.component.scss'],
    imports: [TranslatePipe]
})
export class SloanDownloadConfirmationDialogComponent
  extends KnBrDownloadConfirmationDialogComponent
  implements OnInit
{
  constructor(protected activeModal: NgbActiveModal) {
    super(activeModal);
  }

  ngOnInit(): void {}
}
